/** @format */

import {useEffect, useState} from 'react';

import {
  Close,
  MultilineChartOutlined,
  SensorsOutlined,
  TornadoOutlined,
  TrendingUpOutlined,
  VideoLibraryOutlined,
} from '@mui/icons-material';

import StickyNote from '@mui/icons-material/StickyNote2';

import {useNavigate} from 'react-router-dom';

import {providerNewIconSrc} from 'helpers/imageHelpers';

import {BlueButton} from 'components/buttons/BlueButton';

import {ROUTES} from 'constants/ROUTES';

import ChartsImg from './images/charts.svg?react';
import BlockImg from './images/block.svg?react';

import {
  Badge,
  BadgeBox,
  BgImage,
  CloseButton,
  Content,
  DescriptionBox,
  Footer,
  HeadingText,
  MainBlock,
  RegularText,
  Root,
  SettingsImageWrap,
  Widget,
  WidgetRow,
  WidgetsBox,
  WidgetText,
} from './styles';
import {BANNER_HIDE_KEY} from '../../constants/common';

const Banner = () => {
  const [isHide, setIsHide] = useState<boolean>(true);

  const navigate = useNavigate();

  useEffect(() => {
    setIsHide(localStorage.getItem(BANNER_HIDE_KEY) === 'true');
  }, []);

  const handleClick = () => {
    navigate(`/${ROUTES.HELP_MATERIALS}#digital-cast`);
  };

  const handleHide = () => {
    setIsHide(true);
    localStorage.setItem(BANNER_HIDE_KEY, 'true');
  };

  if (isHide) {
    return null;
  }

  return (
    <Root>
      <Content>
        <HeadingText>Больше, чем кажется</HeadingText>

        <MainBlock>
          <DescriptionBox>
            <RegularText>Вы находитесь на Цифровом слепке.</RegularText>
            <RegularText>
              Это мощный аналитический инструмент, с которым вы можете отслеживать рекламные
              показатели и находить причины аномалий в рекламе.
            </RegularText>
            <RegularText>
              Мы бережно храним всю историю, чтобы она была под рукой, когда понадобится вернуться в
              прошлое.
            </RegularText>
          </DescriptionBox>

          <WidgetsBox>
            <Widget
              bgColor='linear-gradient(0deg, rgba(125, 173, 253, 0.20) 0%, rgba(125, 173, 253, 0.20) 100%)'
              textColor='#7DADFD'
            >
              <WidgetText>Расход бюджета</WidgetText>
              <WidgetRow>
                <MultilineChartOutlined />
                <WidgetText>План и факт</WidgetText>
              </WidgetRow>
            </Widget>

            <Widget
              bgColor='linear-gradient(0deg, rgba(204, 169, 65, 0.20) 0%, rgba(204, 169, 65, 0.20) 100%)'
              textColor='#CCA941'
            >
              <WidgetRow>
                <WidgetText>Заметки</WidgetText>
                <StickyNote />
              </WidgetRow>
              <WidgetText>на таймлайне</WidgetText>
            </Widget>

            <Widget
              bgColor='linear-gradient(0deg, rgba(125, 173, 253, 0.20) 0%, rgba(125, 173, 253, 0.20) 100%)'
              textColor='#7DADFD'
            >
              <WidgetRow>
                <img src={providerNewIconSrc('YANDEX', 20)} alt='' />
                <WidgetText>Яндекс Директ</WidgetText>
              </WidgetRow>
              <WidgetText>Изменения в кабинете</WidgetText>
            </Widget>

            <Widget
              bgColor='linear-gradient(0deg, rgba(242, 139, 138, 0.20) 0%, rgba(242, 139, 138, 0.20) 100%)'
              textColor='#F28B8A'
            >
              <WidgetRow>
                <WidgetText>Сенсоры</WidgetText>
                <SensorsOutlined />
              </WidgetRow>
              <WidgetText>по критичности</WidgetText>
            </Widget>

            <Widget
              bgColor='linear-gradient(0deg, rgba(128, 192, 114, 0.20) 0%, rgba(128, 192, 114, 0.20) 100%)'
              textColor='#80C072'
            >
              <WidgetRow>
                <WidgetText>Ваши KPI</WidgetText>
                <TrendingUpOutlined />
              </WidgetRow>
              <WidgetText>из медиаплана</WidgetText>
            </Widget>

            <Widget
              bgColor='linear-gradient(0deg, rgba(44, 199, 176, 0.20) 0%, rgba(44, 199, 176, 0.20) 100%)'
              textColor='#2CC7B0'
            >
              <WidgetRow>
                <WidgetText>Рекламные</WidgetText>
                <BadgeBox bgColor='rgba(44, 199, 176, 0.30)' textColor='#FAFBFE'>
                  <Badge>CPL</Badge>
                  <Badge>DRR</Badge>
                  <Badge>ROMI</Badge>
                </BadgeBox>
              </WidgetRow>
              <WidgetRow>
                <WidgetText>показатели</WidgetText>
                <BadgeBox bgColor='rgba(44, 199, 176, 0.30)' textColor='#FAFBFE'>
                  <Badge>Клики</Badge>
                  <Badge>и еще 10</Badge>
                </BadgeBox>
              </WidgetRow>
            </Widget>

            <Widget
              bgColor='linear-gradient(0deg, rgba(89, 197, 145, 0.20) 0%, rgba(89, 197, 145, 0.20) 100%)'
              textColor='#59C591'
              iconSize='40px'
            >
              <WidgetRow>
                <WidgetText>
                  Воронка
                  <br />
                  на таймлайне
                </WidgetText>
                <TornadoOutlined />
              </WidgetRow>
            </Widget>

            <Widget
              bgColor='linear-gradient(0deg, rgba(62, 136, 197, 0.20) 0%, rgba(62, 136, 197, 0.20) 100%)'
              textColor='#3E88C5'
            >
              <WidgetText>Внешние события</WidgetText>
              <WidgetRow>
                <BadgeBox bgColor='#3E88C5' textColor='#F9FCFE'>
                  <Badge>Скоро в обновлении</Badge>
                </BadgeBox>
              </WidgetRow>
            </Widget>
          </WidgetsBox>
        </MainBlock>

        <Footer>
          <SettingsImageWrap>
            <BlockImg />
          </SettingsImageWrap>
          <BlueButton size='large' onClick={handleClick}>
            <VideoLibraryOutlined />
            Обучающее видео
          </BlueButton>
        </Footer>
      </Content>

      <BgImage>
        <ChartsImg />
      </BgImage>

      <CloseButton onClick={handleHide}>
        <Close />
      </CloseButton>
    </Root>
  );
};

export {Banner};
